// Termo que só tem cara de telefone: dígitos e separadores comuns.
const PHONE_LIKE_TERM = /^[\d\s+\-().\\]+$/;

// Monta o filtro `.or()` do PostgREST para a busca de leads. O termo digitado
// não pode ir cru pra dentro da string: vírgula, parênteses, aspas e barra
// invertida são sintaxe do filtro (digitar "(11) 99999-9999" ou "Silva, João"
// quebrava a busca com erro 400), e `%`/`_` viram curingas do ilike.

export function sanitizeLeadSearchTerm(raw: string): string {
  return raw
    .replace(/[\\%_]/g, (c) => `\\${c}`)
    .replace(/[,()"]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function removeAccents(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

export interface LeadSearchOptions {
  includePhone?: boolean;
}

// Retorna null quando não há nada pra buscar (termo vazio após a limpeza).
export function buildLeadSearchFilter(raw: string | null | undefined, options: LeadSearchOptions = {}): string | null {
  const { includePhone = true } = options;
  const term = sanitizeLeadSearchTerm(raw ?? '');
  if (!term) return null;

  // search_text (name + email + company_name) é minúsculo e sem acentos no banco.
  const conditions = [`search_text.ilike.%${removeAccents(term)}%`];

  if (includePhone && PHONE_LIKE_TERM.test(term)) {
    // O telefone está salvo de vários jeitos ("+5581981269780", "(81) 98126-9780",
    // "81 98126‑9780" com hífen invisível...). A coluna phone_digits guarda só os
    // dígitos, então qualquer trecho ("81269780", "9780", "8126") encontra todos.
    const digits = term.replace(/\D/g, '');
    if (digits.length >= 3) conditions.push(`phone_digits.ilike.%${digits}%`);
  }

  return conditions.join(',');
}
